import React from "react";
import { motion } from "framer-motion";

const SyntraMetaverseHeroSection = () => (
  <div className="text-center py-10">
    <motion.h1
      className="text-2xl md:text-3xl font-bold text-yellow-200 bg-gray-500 rounded-lg px-4 py-4 mb-6 flex items-center gap-3"
      initial={{ opacity: 0, y: -30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      🌐 Manufacturers Metaverse
    </motion.h1>
    <motion.p
      className="text-lg text-green-800 max-w-2xl mx-auto"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.3, duration: 1 }}
    >
      A virtual ecosystem connecting{" "}
      <strong>Manufacturers</strong>, <strong>Buyers</strong>,{" "}
      <strong>Consumers</strong> and <strong>Services</strong>.
    </motion.p>
  </div>
);

export default SyntraMetaverseHeroSection;
